export default __webpack_public_path__ + "static/media/rightArrow.a3e5837e.svg";